import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import { ReactComponent as SavedDataLightIcon } from '../../../../assets/images/SavedDataLight.svg';
import { ReactComponent as SavedDataDarkIcon } from '../../../../assets/images/SavedDataDark.svg';

export const SavedDataIcon: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'light': {
        return <SavedDataLightIcon />;
      }
      case 'dark': {
        return <SavedDataDarkIcon />;
      }
      default: {
        return <SavedDataLightIcon />;
      }
    }
  };
  return getIcon(theme);
};
